import { KeyValueModel } from "model";
import { EnumTipoPropagandaPessoa } from "model/enums/enum-tipo-propaganda-pessoa";

export const TipoPropagandaPessoaMock: KeyValueModel[] = [
    new KeyValueModel(EnumTipoPropagandaPessoa.NaoExibir, "Não Exibir"),
    new KeyValueModel(EnumTipoPropagandaPessoa.Saurus, "Sim"),
    new KeyValueModel(EnumTipoPropagandaPessoa.Whitelabel, "Somente Whitelabel"),
];
